import React from 'react'
import { Box } from '../Box/Box'

export interface DividerProps {
  strong?: boolean
  color?: string
}

export const Divider: React.FC<DividerProps> = ({ strong = false, color }) => {
  return (
    <Box position="relative">
      <Box
        position="absolute"
        width="100%"
        height={strong ? '2px' : '1px'}
        background={color || 'var(--colors-hairline)'}
      />
    </Box>
  )
}
